import { FC } from "react"

import { StopOutlined } from "@ant-design/icons"

import css from "./PhoneCell.module.scss"

interface PhoneCellProps {
    isPaid: number
    phoneUnavailable?: number
}

export const PhoneCell: FC<PhoneCellProps> = ({ isPaid, phoneUnavailable, children }) => {
    // Если телефон недоступен для звонков
    if (phoneUnavailable === 1) {
        return (
            <div className={css.unavailable}>
                <StopOutlined />
                <span>Без звонков</span>
            </div>
        )
    }

    let PhoneCellClass = css.default
    switch (isPaid) {
        case 1: {
            PhoneCellClass = css.payCall
            break
        }
        case 2: {
            PhoneCellClass = css.notCall
            break
        }
    }
    
    return (
        <div className={PhoneCellClass}>
            {children}
        </div>
    )
}